export default __webpack_public_path__ + "static/bookingmyhotel-3688960a6792e32546cc2818ca6667cf.avif";